import { useApi } from '@hero/context';
import type { MessageSendAPI } from '@hero/api';
import type { UseHookMutateApi } from '../../types/hook-api';
import { useMutationAPI } from '../../utils';

export type UseMessageSendApi = UseHookMutateApi<MessageSendAPI>;

/**
 * Send a transactional order message (WhatsApp waybill today).
 *
 * API from ApiProvider (`api.message.send`). Override via apiConfig.apiFn when needed.
 *
 * Hook API: {@link UseMessageSendApi}
 */
export const useMessageSendApi: UseMessageSendApi = apiConfig => {
  const api = useApi();
  return useMutationAPI({
    entity: 'message',
    apiFn: api.message.send,
    apiConfig,
  });
};
